// extracted by mini-css-extract-plugin
export default {"event__wrapper":"Event_event__wrapper__lTWYo"};